module.exports = __webpack_public_path__ + "img/treasure-chest.c3226b8b.svg";